module.exports = __webpack_public_path__ + "static/media/Louise Ristau Headshot.235098fe.jpeg";